// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2Paqg","textarea":"styles_textarea__7TUwX"};